// Global active-tenant selection for super admin. One source of truth every module reads,
// so tenant routing is chosen once (top app bar) instead of per-module.
import { getPrimaryTenantKey } from '@/utils/tenant/tenants';
import { getLoggedInTenantKeys } from '@/utils/tenant/tenantSessions';

const ACTIVE_TENANT_KEY = 'CF_ACTIVE_TENANT';

function initialActiveTenant() {
  const saved = typeof localStorage !== 'undefined' ? localStorage.getItem(ACTIVE_TENANT_KEY) : null;
  return saved || getPrimaryTenantKey();
}

export default {
  namespaced: true,
  state: {
    activeTenant: initialActiveTenant(),
  },
  getters: {
    // Fall back to the primary login tenant if the saved one isn't currently available
    // (e.g. a stale selection from a previous session whose tenant didn't log in this time).
    activeTenant: (state) => {
      const primary = getPrimaryTenantKey();
      const available = getLoggedInTenantKeys();
      if (state.activeTenant && (state.activeTenant === primary || available.includes(state.activeTenant))) {
        return state.activeTenant;
      }
      return primary;
    },
  },
  mutations: {
    SET_ACTIVE_TENANT(state, tenantKey) {
      if (!tenantKey) return;
      state.activeTenant = tenantKey;
      if (typeof localStorage !== 'undefined') localStorage.setItem(ACTIVE_TENANT_KEY, tenantKey);
    },
    CLEAR_ACTIVE_TENANT(state) {
      state.activeTenant = getPrimaryTenantKey();
      if (typeof localStorage !== 'undefined') localStorage.removeItem(ACTIVE_TENANT_KEY);
    },
  },
  actions: {
    setActiveTenant({ commit }, tenantKey) {
      commit('SET_ACTIVE_TENANT', tenantKey);
    },
  },
};
